import { Quill } from 'react-quill-new';

const Embed = (Quill as any).import('blots/embed');

export type VariableCategory = 'child' | 'recipient' | 'school' | 'sender' | 'other';

export const VARIABLE_CATEGORY_STYLES: Record<
  VariableCategory,
  {
    bg: string;
    text: string;
    border: string;
    title: string;
  }
> = {
  child: { bg: '#dbeafe', text: '#1e40af', border: '#93c5fd', title: 'Child' },
  recipient: { bg: '#dcfce7', text: '#166534', border: '#86efac', title: 'Recipient' },
  school: { bg: '#ede9fe', text: '#6d28d9', border: '#c4b5fd', title: 'School' },
  sender: { bg: '#fef3c7', text: '#92400e', border: '#fcd34d', title: 'Sender' },
  other: { bg: '#f1f5f9', text: '#475569', border: '#cbd5e1', title: 'Other' }
};

export function getVariableCategory(variable: string): VariableCategory {
  if (variable.startsWith('{{child')) return 'child';
  if (variable.startsWith('{{recipient')) return 'recipient';
  if (variable.startsWith('{{school')) return 'school';
  if (variable.startsWith('{{sender')) return 'sender';
  return 'other';
}

export function getVariableDisplayLabel(variable: string): string {
  const inner = variable.replace(/^\{\{/, '').replace(/\}\}$/, '');
  return inner
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, s => s.toUpperCase())
    .trim();
}

class VariableChipBlot extends Embed {
  static blotName = 'variable-chip';
  static tagName = 'span';
  static className = 'ql-variable-chip';

  static create(value: string) {
    const node = (Embed as any).create.call(this);
    const category = getVariableCategory(value);

    node.setAttribute('data-variable', value);
    node.setAttribute('data-category', category);
    node.setAttribute('contenteditable', 'false');
    node.className = `ql-variable-chip ql-variable-chip--${category}`;
    const label = document.createElement('span');
    label.className = 'ql-variable-chip__label';
    label.textContent = getVariableDisplayLabel(value);
    const remove = document.createElement('span');
    remove.className = 'ql-variable-chip__remove';
    remove.setAttribute('data-variable-remove', 'true');
    remove.setAttribute('role', 'button');
    remove.setAttribute('title', 'Remove variable');
    remove.textContent = '×';
    node.appendChild(label);
    node.appendChild(remove);

    return node;
  }

  static value(node: HTMLElement) {
    return node.getAttribute('data-variable') || '';
  }
}

// Register once on import
try {
  Quill.register({ 'formats/variable-chip': VariableChipBlot }, true);
} catch (_) {}

export { VariableChipBlot };
